module.exports = __webpack_public_path__ + "img/icon-camera.1c745d28.svg";